import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InspectionModalService {

  private selectedInspectionSubject = new BehaviorSubject<any>(null);
  public selectedInspection$ = this.selectedInspectionSubject.asObservable();

  constructor() { }

  setSelectedInspection(inspection: any): void {
    this.selectedInspectionSubject.next(inspection);
  }

  getSelectedInspection(): any | null {
    return this.selectedInspectionSubject.value;
  }

  clearSelectedInspection(): void {
    this.selectedInspectionSubject.next(null);
  }
}
